export default function cropText(text, limit = 145) {
  if(text.length > limit) {
    text = text.substring(0,(limit-3))+"...";
  }
  return text;
}
